export const DETAIL_FIELDS = ["first", "second", "third"];
export const PHOTOS_VERIFICATION_CITIES = ["Barcelona", "Madrid"];
